//@ts-nocheck
import { IRootStore } from "../../stores";
import { STEPS } from "../../stores/rootStore";
import { useFormIndexStep } from "../../components/FormWrapper/data";
import guarantorInfoData from "../../tutor-revamp/formData/guarantorInfo.json";

function buildWrapperProps(store: IRootStore, step: string) {
  const options = {
    [STEPS.VIDEO_SUMMARY]: {
      store: store.others,
      completed: store.others.videoSummary.completed,
      formHeader: "Video Recording",
      lockedDescription: "Record a cover video of yourself",
    },
    [STEPS.VERIFY_EMAIL]: {
      store,
      completed: store.emailVerified,
      formHeader: "Email Verification",
      lockedDescription: "Verify your email",
    },
    [STEPS.VERIFICATION]: {
      store: store.identity,
      previousStep: STEPS.TEACHING_PROFILE,
      formHeader: "Profile and ID Verification",
      lockedDescription: "Verify your identity in order to complete steps",
      isCollapsed: true,
      buttonText: "Save and Continue",
      buttonIsDisabled: !store.identity.completed,
      formSummary: ["Profile Picture uploaded", "Identity Uploaded"],
      completed: store.identity.completed,
    },
    [STEPS.UPLOAD_EDUCATION]: {
      store: store.educationWorkHistory,
      formHeader: "Education History",
      lockedDescription: "Fill in your education details",
    },
    [STEPS.UPLOAD_WORK]: {
      store: store.educationWorkHistory,
      formHeader: "Work History",
      lockedDescription: "Fill in your work history",
    },
    [STEPS.GUARANTOR_INFO]: {
      previousStep: STEPS.VERIFY_EMAIL,
      store: store.educationWorkHistory,
      formHeader: guarantorInfoData.formTitle.header,
      description: guarantorInfoData.formTitle.subHeader,
      displayType: "complex",
      hideStep: true,
      shouldDisplayButton: false,
      lockedDescription: guarantorInfoData.formTitle.subHeader,
      buttonText: guarantorInfoData.buttonText.saveAndContinue,
      textData: guarantorInfoData,
      completed: store.educationWorkHistory.guarantorsCompleted,
    },
  };
  return {
    ...options[step],
    label: step,
    loading: store.loading,
  };
}

export const useTutorApplicationFlow = (
  store: IRootStore,
  currentStep?: string
) => {
  const {
    onError,
    activeStep,
    completedForm,
    formIndex,
    steps,
    setCompletedForm,
    handleFormSubmit,
  } = useFormIndexStep(store, []);

  async function onSubmitSection(formData: any, label = "") {
    let options = {
      [STEPS.VERIFICATION]: STEPS.VIDEO_SUMMARY,
      [STEPS.VIDEO_SUMMARY]: STEPS.VERIFY_EMAIL,
      [STEPS.VERIFY_EMAIL]: STEPS.GUARANTOR_INFO,
      [STEPS.GUARANTOR_INFO]: STEPS.UPLOAD_EDUCATION,
      [STEPS.UPLOAD_EDUCATION]: STEPS.UPLOAD_WORK,
      [STEPS.UPLOAD_WORK]: "",
    };
    let _activeStep =
      label || (store.isEditAction ? store.editIndex : activeStep);
    let newStep = options[_activeStep];
    return store
      .onFormSubmit(formData, _activeStep, newStep)
      .then(() => {
        if (newStep === "") {
          setCompletedForm(true);
        }
        if (store.isEditAction || label) {
          // this ensures that the current step does not change on edit.
          store.setEditAction(false);
        } else {
          if (activeStep === STEPS.VIDEO_SUMMARY && store.emailVerified) {
            newStep = STEPS.UPLOAD_EDUCATION;
          }
          handleFormSubmit(newStep, activeStep);
        }
      })
      .catch((error) => {
        onError();
        throw error;
      });
  }

  function getFormWrapperProps(step: any): any {
    let result = buildWrapperProps(store, step);
    const formOrder = [
      STEPS.VERIFICATION,
      STEPS.VIDEO_SUMMARY,
      STEPS.VERIFY_EMAIL,
      STEPS.GUARANTOR_INFO,
      STEPS.UPLOAD_EDUCATION,
      STEPS.UPLOAD_WORK,
    ];
    let stepIndex = formOrder.indexOf(step);
    let currentStepIndex = formOrder.indexOf(activeStep);
    let isCompleted =
      currentStepIndex > stepIndex || !formOrder.includes(activeStep);
    if (
      [
        STEPS.UPLOAD_WORK,
        STEPS.UPLOAD_EDUCATION,
        STEPS.GUARANTOR_INFO,
      ].includes(step)
    ) {
      if (currentStepIndex >= 2 && store.emailVerified) {
        isCompleted = true;
      }
    }
    return {
      ...result,
      onSubmit: onSubmitSection,
      currentStep: activeStep,
      isCompleted: isCompleted,
      afterUpload: () => store.onFormSubmit({}, step, ""),
    };
  }

  return { activeStep, steps, getFormWrapperProps, completedForm, formIndex };
};
